module.exports = __webpack_public_path__ + "site/img/188.59570f71.jpg";